// extracted by mini-css-extract-plugin
export var buttons = "bC_cr";
export var left = "bC_bT";
export var media = "bC_g7";
export var right = "bC_cv";
export var section = "bC_d";
export var selected = "bC_bg";
export var signature = "bC_g6";
export var testimonial = "bC_g5";
export var text = "bC_b0";
export var textContainer = "bC_cW";
export var video = "bC_gY";